export const verifyPasswords = (pwd1, pwd2) => {
    if(pwd1 !== pwd2) {
        return 'notEqual';
    } else if (pwd1.length < 6) {
        return 'short';
    } else if (pwd1 === pwd1.toLowerCase()) {
        return 'noUpperCase';
    } else {
        return null
    }
}